var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnsfailedtodeliverbybot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3636_2929)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.0397V28.37C10 29.0135 10.5217 29.5351 11.1652 29.5351H11.5535V24.8745H11.1652C10.5217 24.8745 10 25.3962 10 26.0397Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1345 24.8745H31.7461V29.5351H32.1345C32.7779 29.5351 33.2996 29.0135 33.2996 28.37V26.0397C33.2996 25.3962 32.778 24.8745 32.1345 24.8745Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.595 15.9416C23.5926 16.8636 22.9443 17.6578 22.0415 17.8447V19.8254H21.2647V17.8447C20.2634 17.6403 19.5919 16.6949 19.7286 15.6822C19.8653 14.6695 20.7634 13.936 21.783 14.0044C22.8026 14.0728 23.5947 14.9197 23.595 15.9416Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3097 27.2048C26.9532 27.2048 27.4748 26.6832 27.4748 26.0397C27.4748 25.3962 26.9532 24.8745 26.3097 24.8745C25.6662 24.8745 25.1445 25.3962 25.1445 26.0397C25.1445 26.6832 25.6662 27.2048 26.3097 27.2048Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9894 27.2048C17.6329 27.2048 18.1545 26.6832 18.1545 26.0397C18.1545 25.3962 17.6329 24.8745 16.9894 24.8745C16.3459 24.8745 15.8242 25.3962 15.8242 26.0397C15.8242 26.6832 16.3459 27.2048 16.9894 27.2048Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6442 20.6025H14.6623C13.3753 20.6025 12.332 21.6459 12.332 22.9328V31.4773C12.332 32.7611 13.3704 33.8031 14.6542 33.8076C14.7584 33.8062 14.8588 33.8465 14.9332 33.9194C15.0076 33.9923 15.0499 34.0918 15.0508 34.196V36.1889C15.0506 36.3322 15.1294 36.464 15.2558 36.5317C15.3821 36.5993 15.5355 36.5919 15.6547 36.5124L19.5172 33.9381C19.6443 33.8534 19.7936 33.808 19.9463 33.8077H28.6442C29.9312 33.8077 30.9745 32.7643 30.9745 31.4774V22.9328C30.9745 21.6459 29.9312 20.6025 28.6442 20.6025ZM16.9927 27.9818C15.9202 27.9818 15.0507 27.1124 15.0507 26.0399C15.0507 24.9674 15.9202 24.098 16.9927 24.098C18.0651 24.098 18.9346 24.9674 18.9346 26.0399C18.9333 27.1119 18.0646 27.9806 16.9927 27.9818ZM23.9246 29.3528C23.9001 29.392 23.3058 30.3121 21.6533 30.3121C20.0007 30.3121 19.4065 29.392 19.382 29.3528C19.272 29.172 19.327 28.9365 19.5056 28.8231C19.6842 28.7097 19.9207 28.76 20.0376 28.9364C20.0609 28.9699 20.4671 29.5353 21.6533 29.5353C22.8499 29.5353 23.253 28.9601 23.2693 28.9357C23.3881 28.7594 23.6257 28.71 23.8049 28.8242C23.9828 28.938 24.0361 29.1736 23.9246 29.3528ZM26.3139 27.9818C25.2414 27.9818 24.372 27.1124 24.372 26.0399C24.372 24.9674 25.2414 24.098 26.3139 24.098C27.3864 24.098 28.2558 24.9674 28.2558 26.0399C28.2545 27.1119 27.3858 27.9806 26.3139 27.9818Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 14,
    r: 5.5,
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4965 17.1439V12.9787H32.6517V17.1439H31.4965ZM32.0768 12.4417C31.9051 12.4417 31.7577 12.3848 31.6348 12.2709C31.5137 12.1552 31.4531 12.0169 31.4531 11.856C31.4531 11.6969 31.5137 11.5604 31.6348 11.4465C31.7577 11.3308 31.9051 11.2729 32.0768 11.2729C32.2486 11.2729 32.395 11.3308 32.5161 11.4465C32.6391 11.5604 32.7005 11.6969 32.7005 11.856C32.7005 12.0169 32.6391 12.1552 32.5161 12.2709C32.395 12.3848 32.2486 12.4417 32.0768 12.4417Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3636_2929",
    x1: 54,
    y1: -13.5,
    x2: 6,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00937462,
    stopColor: "#FFC451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsfailedtodeliverbybot);
export default __webpack_public_path__ + "static/media/ansfailedtodeliverbybot.f62f32613266672292564b3da285eac9.svg";
export { ForwardRef as ReactComponent };